import React, { useState } from 'react';
import './tooltip.css';

const Tooltip = ({ children, text, position = 'top' }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div
      className="tooltip-container"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      onFocus={() => setVisible(true)}
      onBlur={() => setVisible(false)}
    >
      {children}
      <div
        className={`
          tooltip-box
          tooltip-${position}
          ${visible ? 'visible' : ''}
        `}
        role="tooltip"
      >
        {text}
      </div>
    </div>
  );
};


export default Tooltip;
